import React from 'react';
import ProgressBar from "../ProgressBar";
import ModalContainer from '../ModalContainer';
import ModalContent from '../ModalContent';
import ModalHeader from '../ModalHeader';
import styles from './styles.module.scss';

const UploadingFilePopUp = ({
                              showUploadingFilePopUp,
                              hideUploadingFilePopUp,
                              progress,
                              message
                            }) => {

  return (
    <ModalContainer show={showUploadingFilePopUp} onHide={hideUploadingFilePopUp} size={'md'}>
      <ModalHeader header={message}/>
      <ModalContent customClassnames={'bg-transparent'}>
        <div className={styles.progressBar}>
          <ProgressBar progress={progress}/>
        </div>
      </ModalContent>
    </ModalContainer>
  )
};

export default UploadingFilePopUp;